import MassageIcon from '../../assets/icons/basistypes/svg/Massage.svg'
import TrainingIcon from '../../assets/icons/basistypes/svg/Training.svg'
import YogaIcon from '../../assets/icons/basistypes/svg/Yoga.svg'

const serviceIcons = [MassageIcon, TrainingIcon, YogaIcon]

interface AddressTemplateProps {
    onChangeAddress: React.ChangeEventHandler<HTMLInputElement>
    onKeyDownAddress: React.KeyboardEventHandler<HTMLInputElement>
    onSubmitAddress: () => void
    showError: boolean
}

export { serviceIcons }
export type { AddressTemplateProps }
